import React, { useMemo } from "react";
import { Flex, Text, HelpIndicator } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { PepExposureCategory } from "#graphql/supergraphEnums";
import { PepExposureCategory as PepExposureCategoryType } from "#graphql/supergraphTypes";
import { amlStatusField, pepTooltipInfo } from "../styles_vanilla.css";
import { PEP_TOOLTIP_CATEGORIES } from "./constants";
import { FieldLabel } from "./FieldLabel";

const PEP_TOOLTIP_CONTENT = (
  <>
    <Text>
      This indicates exposure to a Politically Exposed Person (PEP) via an ownership or control
      nexus; the root investor may or may not be a PEP themselves. Exposure is classified into
      the following categories:
    </Text>
    <ul>
      {PEP_TOOLTIP_CATEGORIES.map(({ label, description }) => (
        <li key={label}>
          <Text className={pepTooltipInfo}>
            {label}: {description}
          </Text>
        </li>
      ))}
    </ul>
  </>
);

export const PepItem = ({ pepCategory }: { pepCategory?: PepExposureCategoryType | null }) => {
  const pepValue = useMemo(() => {
    switch (pepCategory) {
      case PepExposureCategory.Category_1:
        return "Category 1";
      case PepExposureCategory.Category_2:
        return "Category 2";
      case PepExposureCategory.Category_3:
        return "Category 3";
      case PepExposureCategory.NotApplicable:
        return "N/A";
    }
  }, [pepCategory]);

  const showIcon = useMemo(() => {
    return pepCategory && pepCategory != PepExposureCategory.NotApplicable;
  }, [pepCategory]);

  return (
    <div className={amlStatusField}>
      <FieldLabel label="PEP exposure" tooltip={PEP_TOOLTIP_CONTENT} />
      <Flex alignItems="center" gap={4}>
        {showIcon && (
          <Icon type="exclamation-triangle" variant="outline" color={Colors.Warning600} />
        )}
        {pepValue ? (
          <Text variant="strong-lg">{pepValue}</Text>
        ) : (
          <HelpIndicator
            id="pep_exposure_na_tt"
            content="No evaluation has been done by Fund Administration team yet."
          >
            <Text variant="strong-lg">--</Text>
          </HelpIndicator>
        )}
      </Flex>
    </div>
  );
};
